import React from 'react'
import { css } from '@linaria/core'
import PropTypes from 'prop-types'
import { deprecatedPropType } from '@fs/zion-frontend-friends'
import { Link } from '@fs/zion-router-base'
import Tooltip from './Tooltip'
import { colors } from '../theme'

export const defaultOpenTimeout = 1200

const actionCss = css`
  margin-top: 8px;
`
const keyboardShortcutCss = css`
  color: ${colors.transparent.gray40};
  margin: 4px 0;
`

export default function DescriptionTooltip({
  label,
  description,
  linkProps, // Deprecated, remove in v11
  keyboardShortcut,

  /** [HIDDEN]: For internal Zion-UI use only */
  openTimeout,

  ...props
}) {
  openTimeout = openTimeout ?? defaultOpenTimeout
  return (
    <Tooltip
      {...props}
      morePadding={!!description || !!keyboardShortcut || !!linkProps}
      label={
        label || description ? (
          <>
            {label && <div>{label}</div>}
            {keyboardShortcut && <div className={keyboardShortcutCss}>({keyboardShortcut})</div>}
            {description}
            {linkProps && (
              <div className={actionCss}>
                <Link {...linkProps} />
              </div>
            )}
          </>
        ) : null
      }
      description={description}
      interactive={!!linkProps}
      openTimeout={openTimeout}
    />
  )
}

DescriptionTooltip.propTypes = {
  /** Text displayed in the tooltip. If you don't provide something, the tooltip won't show up. */
  label: PropTypes.oneOfType([PropTypes.element, PropTypes.node]),

  // Used in Tooltip
  /** A single dom node or component that renders a single dom node to which the tooltip gets attached. */
  target: PropTypes.oneOfType([PropTypes.element, PropTypes.node]),

  /** The description text for the tooltip. Max 140 characters. */
  description: PropTypes.string,

  /** Keyboard shortcut for some action that the anchoring button does. */
  keyboardShortcut: PropTypes.string,

  /** Deprecated: tooltips should not be interactive. */
  linkProps: deprecatedPropType(
    'DescriptionTooltip: `linkProps` prop has been deprecated. See https://beta.familysearch.org/frontier/zion/?path=/docs/ui-foundation-feedback-overlays-tooltipoverlay'
  ),

  // Used by ComboTooltip
  /** [HIDDEN]: How long to wait before opening after trigger. */
  // openTimeout: PropTypes.string,
}
